import React, { useEffect, useRef, useState } from "react";
import makeStyles from "@material-ui/core/styles/makeStyles";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
  },
  carousel: {
    flexGrow: 1,
    scrollSnapType: "x mandatory",
    scrollBehavior: "smooth",
    overflowY: "hidden",
    overflowX: "scroll",
    display: "flex",
    "&::-webkit-scrollbar": {
      backgroundColor: "transparent",
      height: 0,
    },
  },
  carouselItem: {
    scrollSnapAlign: "center",
    //minWidth: '80vw',
    margin: theme.spacing(2),
    display: "flex",
    flexDirection: "column",
    marginBottom: 0,
    marginTop: 0,
  },
  bulletList: {
    listStyle: "none",
    padding: 0,
    margin: 0,
    display: "flex",
    justifyContent: "center",
    marginTop: "12px",
    marginBottom: "16px",
    "& a": {
      display: "block",
      width: "8px",
      height: "8px",
      backgroundColor: theme.palette.primary.light,
      marginRight: theme.spacing(1),
      borderRadius: "50%",
    },
  },
  skeletonBulletContainer: {
    width: "8px",
    height: "8px",
    marginRight: theme.spacing(1),
  },
  activeBullet: {
    "& a": {
      backgroundColor: theme.palette.secondary.main,
    },
  },
}));

export const HTMLCarousel = ({ children, forwardRef }) => {
  const classes = useStyles();
  const [currentIndex, setCurrentIndex] = useState(0);
  const elementRefs = useRef([]);
  const rootRef = useRef();

  useEffect(() => {
    const observer = new IntersectionObserver(
      function (entries, observer) {
        // find the entry with the largest intersection ratio
        const activated = entries.reduce(function (max, entry) {
          return entry.intersectionRatio > max.intersectionRatio ? entry : max;
        });
        if (activated.intersectionRatio > 0) {
          const index = elementRefs.current.indexOf(activated.target);
          if (index >= 0) {
            setCurrentIndex(index);
          }
          console.log(
            "Element",
            activated,
            index,
            activated.intersectionRatio,
            activated.target,
            elementRefs.current,
          );
        }
      },
      {
        root: rootRef.current,
        threshold: 1,
      },
    );

    console.log("Root ref", rootRef);
    for (const element of elementRefs.current) {
      observer.observe(element);
    }

    return () => {
      observer.disconnect();
      /*
            for (const element of elementRefs.current) {
                observer.unobserve(element);
            }*/
    };
  }, []);
  return (
    <>
      <div className={classes.carousel} ref={forwardRef}>
        {children.map((child, index) => {
          console.log("The child is", child);
          return React.cloneElement(child, {
            key: child.id || child.key,
            forwardRef: (el) => {
              console.log("Callback ref is ran!", index);
              elementRefs.current[index] = el;
            },
            index,
          });
        })}
      </div>
      <HTMLCarouselBullets slides={children} currentIndex={currentIndex} />
    </>
  );
};

export const HTMLCarouselItem = ({ children, index, forwardRef }) => {
  const classes = useStyles();
  console.log("The forward ref is", forwardRef, index, children);
  return (
    <div
      className={classes.carouselItem}
      id={"slide--" + index}
      ref={(el) => forwardRef && forwardRef(el)}
    >
      {children}
    </div>
  );
};

export const HTMLCarouselBullets = ({ slides, currentIndex }) => {
  const classes = useStyles();
  const [t] = useTranslation();

  return (
    <ul className={classes.bulletList}>
      {slides.map((dummy, index) => {
        return (
          <li className={currentIndex == index ? classes.activeBullet : ""}>
            <a
              href={"#slide--" + index}
              aria-label={t("Go to slide %s", {
                postProcess: "sprintf",
                sprintf: [index + 1],
              })}
              aria-current={index === currentIndex ? "page" : undefined}
            ></a>
          </li>
        );
      })}
    </ul>
  );
};
